import { support_features, training_supports } from 'data/Pricing/EntrpriseFeatures'
import React from 'react'

const TrainingSupportFeatureCard = () => {
  return (
    <div className=" w-full ">
      <div className=" w-full flex flex-col md:items-center md:justify-center  gap-3 md:gap-4  mb-12 md:mb-[72px] ">
        <p className="  text-base  font-semibold text-primary md:text-center">Support</p>
        <h2 className="h2  text-center">Obsessed with your success</h2>
        <p className=" text-lightGray text-[18px] font-medium  leading-[27px] max-w-screen-md mr-0 md:text-center">
          Tradly's customer success team becomes an extension of your team. We offer strategic
          guidance as well as training. And our support team always has your back, so rest assured
          and end enjoy high-priority help.
        </p>
      </div>

      <div className=" grid  grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-x-8  gap-y-10 md:gap-y-12">
        {training_supports.map((feature) => {
          return (
            <div className=" flex items-start md:justify-center  flex-col  md:text-center">
              <div className=" mb-6 flex items-center justify-center text-primary h-10 w-10 bg-primary/40  ring-8 ring-primary/10  rounded-full  md:mx-auto ">
                {feature.icon}
              </div>
              <h4 className=" h4  mb-2 text-center  md:mx-auto">{feature.title} </h4>
              <p className="text-lightGray text-base font-medium  leading-[24px]">
                {feature.description}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default TrainingSupportFeatureCard
